import { motion } from 'framer-motion';
import { Activity, DollarSign, Hash, Server } from 'lucide-react';
import { fmtUSD, fmtTokens } from '../lib/estimate.js';

export function StatsDock({ stats }) {
  if (!stats) return null;
  // Defensive: gateway stats shape may vary; render what we have.
  const totalRequests = stats.requests ?? stats.total ?? stats.count;
  const totalTokens = stats.tokens ?? stats.totalTokens;
  const totalCost = stats.cost ?? stats.totalCost;
  const uptime = stats.uptime ?? stats.uptimeMs;

  const items = [
    { icon: Activity, label: 'requests', value: totalRequests ?? '—' },
    { icon: Hash, label: 'tokens', value: totalTokens != null ? fmtTokens(totalTokens) : '—' },
    { icon: DollarSign, label: 'cost', value: totalCost != null ? fmtUSD(totalCost) : '—' },
    { icon: Server, label: 'uptime', value: uptime ? fmtUptime(uptime) : '—' },
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.4 }}
      className="panel grid grid-cols-2 gap-3 p-3 md:grid-cols-4"
    >
      {items.map((it) => (
        <div key={it.label} className="flex items-center gap-3 rounded-xl bg-bg-deep/40 px-3 py-2">
          <it.icon className="h-4 w-4 text-accent-cyan-light" />
          <div className="flex flex-col">
            <span className="font-mono text-[10px] uppercase tracking-[0.16em] text-ink-dim">{it.label}</span>
            <span className="font-mono text-sm tabular-nums text-ink-primary">{it.value}</span>
          </div>
        </div>
      ))}
    </motion.div>
  );
}

function fmtUptime(ms) {
  if (typeof ms !== 'number') return String(ms);
  const s = Math.floor(ms / 1000);
  const d = Math.floor(s / 86400);
  const h = Math.floor((s % 86400) / 3600);
  const m = Math.floor((s % 3600) / 60);
  if (d > 0) return `${d}d ${h}h`;
  if (h > 0) return `${h}h ${m}m`;
  return `${m}m`;
}
